import { get } from 'lodash-es';

export const checkModsRecordForAbTestRecipe = (modsData, campaignName, recipeName) =>
  !!get(modsData, 'seller.abTestBucketing', []).find(test => test === `${campaignName}:${recipeName}`);

export const hasCampaign = (sellerData, campaignName) => {
  const abTestBucketing = sellerData?.abTestBucketing ?? [];
  return !!abTestBucketing.find(test => test?.startsWith(`${campaignName}:`));
};
